module.exports = __webpack_public_path__ + "img/5.85831879.jpg";